module.exports = __webpack_public_path__ + "static/media/ukulele.5495bb5e.png";